import React, { useEffect, useRef, useState, useMemo } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { IonPage } from "@ionic/react";
import { Row, Col } from "antd";
import { PlusOutlined, DeleteFilled } from "@ant-design/icons";

//
import _ from "lodash";

//
import ProductProfileEdit from "../ProductProfileEdit";

const RequestDetailEdit = ({ state = {}, allianceShops }) => {
  const { data, form, onChange } = state;

  return (
    <Row justify="space-evenly" style={{ width: "100%", margin: "1rem 0 5rem 0" }}>
      <Col span={18}>
        <ProductProfileEdit
          state={{
            data: data,
            form: form,
            onChange: onChange,
          }}
          allianceShops={allianceShops}
        />
      </Col>
    </Row>
  );
};

export default RequestDetailEdit;
